import Profile from 'models/Profile';

// The provider types a client's lists can hold: the types it manages but doesn't provide itself.
// Mirrors PreferredProvider::Selectable on the API, which is what actually enforces it.
export const selectablePreferredProviderTypes = (profile: Profile) => {
  const providedIds = new Set(profile.actingClient.providedProviderTypes.map((type) => type.id));

  return profile.actingClient.managedProviderTypes.filter((type) => !providedIds.has(type.id));
};
